
import Container from "@mui/material/Container";

export default function ContainerNode({
  sx, children,
  ...props
}: any) {
  return (
    <Container sx={sx} {...props}>
      {children}
    </Container>
  );
}
